import { useTranslation } from "react-i18next";
import { getDisplayDatetime } from "../../helpers/display_help";
import { Fragment } from "react";
import { Button } from "reactstrap";

function AdminSimRow(props) {
    const { t } = useTranslation();
    const data = props.data;

    return (
        <Fragment>
            <tr>
                <td className="fw-medium">{data["id"]}</td>
                <td>{props.companyName}</td>
                <td>{data["sim_card_number"]}</td>
                <td>{data["phone_number"]}</td>
                <td>{data["vendor_name"]}</td>
                <td>{data["is_effective"] ? t('PageAdmin.SimCardStatus.Normal') : t('PageAdmin.SimCardStatus.Stopped')}</td>
                <td>{getDisplayDatetime(data["created_at"] * 1000)}</td>
                <td>{getDisplayDatetime(data["updated_at"] * 1000)}</td>
                <td style={{padding: "0.51rem 0.6rem"}}>
                    <Button className="btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); props.onClickModify();}}>{t('Common.Btn.Modify')}</Button>
                </td>
            </tr>
        </Fragment>
    );
}

export default AdminSimRow;